
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeadsPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.2 41.31a17.43 17.43 0 0 0-6.035 1.072 16.016 16.016 0 0 0-5.117 3.053 14.094 14.094 0 0 0-3.42 4.57 12.785 12.785 0 0 0-1.2 5.389c0 1.849.408 3.68 1.2 5.389a14.092 14.092 0 0 0 3.42 4.569 16.016 16.016 0 0 0 5.117 3.053 17.43 17.43 0 0 0 6.036 1.072V41.31zm67.6 0c2.07 0 4.122.365 6.035 1.072a16.008 16.008 0 0 1 5.117 3.053 14.097 14.097 0 0 1 3.42 4.57c.792 1.708 1.2 3.54 1.2 5.389 0 1.849-.408 3.68-1.2 5.389a14.095 14.095 0 0 1-3.42 4.569 16.008 16.008 0 0 1-5.117 3.053 17.43 17.43 0 0 1-6.036 1.072V41.31z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.526 101.472c6.372-.951 12.826-3.175 17.163-7.515 5.39-5.39 9.59-14.526 9.59-22.698V43.452c0-8.171-4.2-16.458-9.59-21.846-5.387-5.39-13.674-9.588-21.845-9.588h-4.077c-8.172 0-16.459 4.198-21.846 9.588-5.39 5.388-9.589 13.675-9.589 21.846v27.805m-.131.473c-7.556-.589-13.52-7.426-13.52-15.772 0-8.35 5.964-15.186 13.52-15.774M93.799 71.73c7.557-.589 13.52-7.425 13.52-15.773 0-8.349-5.963-15.185-13.52-15.773",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeMiterlimit: 22.926,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M60 92.01a9.013 9.013 0 1 1 0 18.026 9.013 9.013 0 0 1 0-18.026z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M26.2 41.31a17.43 17.43 0 0 0-6.035 1.072 16.016 16.016 0 0 0-5.117 3.053 14.094 14.094 0 0 0-3.42 4.57 12.785 12.785 0 0 0-1.2 5.389c0 1.849.408 3.68 1.2 5.389a14.092 14.092 0 0 0 3.42 4.569 16.016 16.016 0 0 0 5.117 3.053 17.43 17.43 0 0 0 6.036 1.072V41.31zM93.8 41.31c2.07 0 4.122.365 6.035 1.072a16.008 16.008 0 0 1 5.117 3.053 14.097 14.097 0 0 1 3.42 4.57c.792 1.708 1.2 3.54 1.2 5.389 0 1.849-.408 3.68-1.2 5.389a14.095 14.095 0 0 1-3.42 4.569 16.008 16.008 0 0 1-5.117 3.053 17.43 17.43 0 0 1-6.036 1.072V41.31z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n    <path d=\"M66.526 101.472c6.372-.951 12.826-3.175 17.163-7.515 5.39-5.39 9.59-14.526 9.59-22.698V43.452c0-8.171-4.2-16.458-9.59-21.846-5.387-5.39-13.674-9.588-21.845-9.588h-4.077c-8.172 0-16.459 4.198-21.846 9.588-5.39 5.388-9.589 13.675-9.589 21.846v27.805M26.201 71.73c-7.556-.589-13.52-7.426-13.52-15.772 0-8.35 5.964-15.186 13.52-15.774M93.799 71.73c7.557-.589 13.52-7.425 13.52-15.773 0-8.349-5.963-15.185-13.52-15.773\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-miterlimit=\"22.926\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M60 92.01a9.013 9.013 0 1 1 0 18.026 9.013 9.013 0 0 1 0-18.026z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/headsPhone.58472911ff12be7a9d2e7baf450fea02.svg"),
        {
          React: SvgHeadsPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      